import { NetworkStatus, useLazyQuery, } from '@apollo/client';
import { useEffect, useRef } from 'react';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
export default function useGQLQuery(query, options = {}) {
    const { lazy = false, skip = false, ...queryOptions } = options;
    const [fetch, { loading, data, error, networkStatus, fetchMore, refetch }] = useLazyQuery(query, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
        ...queryOptions,
    });
    const firstFetchCalled = useRef(false);
    useEffect(() => {
        if (!lazy && !skip) {
            firstFetchCalled.current = true;
            fetch();
        }
    }, [skip]);
    const state = {
        loading,
        data,
        error,
        fetchingMore: networkStatus === NetworkStatus.fetchMore,
        refetching: networkStatus === NetworkStatus.refetch,
        networkStatus,
    };
    const actions = {
        fetch: useStableCallback((variables) => {
            return fetch({ variables });
        }),
        fetchMore: useStableCallback((variables) => {
            return fetchMore({ variables });
        }),
        refetch: useStableCallback((variables) => {
            return refetch(variables);
        }),
    };
    return [state, actions];
}
